import { render, staticRenderFns } from "./account-reset.vue?vue&type=template&id=6370ee65&scoped=true"
import script from "./account-reset.vue?vue&type=script&lang=js"
export * from "./account-reset.vue?vue&type=script&lang=js"
import style0 from "./account-reset.vue?vue&type=style&index=0&id=6370ee65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370ee65",
  null
  
)

export default component.exports